<template>
  <div class="modal -video" @click="$emit('close')">
    <div class="modal__content -video" @click.stop>
      <iframe
        :src="`${video.url}${video.id}${getQueryString(video.options)}`"
        frameborder="0"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border-radius: 8px"
        allowfullscreen
        title="youtube"
        allow="autoplay"
      />
      <div class="modal__header--close button -right" @click="$emit('close')">
        Fermer
        <div class="button__icon">
          <Icon id="close" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/global/Icon.vue'

export default {
  name: 'Video',
  components: { Icon },
  props: {
    youtubeId: {
      type: String,
      default: 'NpEaa2P7qZI',
    },
  },
  data() {
    return {
      video: {
        url: 'https://www.youtube.com/embed/',
        id: this.youtubeId,
        options: { controls: 0, autoplay: 1 },
      },
    }
  },
  methods: {
    getQueryString(options) {
      return !options
        ? ''
        : `?${Object.entries(options)
            .map((keyValue) => keyValue.join('='))
            .join('&')}`
    },
  },
}
</script>
